import { selfServiceApiClient } from 'config/selfServiceApi';
import { trimString } from 'shared/helpers/common';

const urlEncoded = 'application/x-www-form-urlencoded';

const unAuthHeader = () => {
  const headers = new Headers();
  headers.append('Content-Type', urlEncoded);
  headers.append('Accept', urlEncoded);
  return headers;
};

/**
 *
 * @param {*} data
 * @returns {Promise<import('axios').AxiosResponse<any, any>>}
 */
export const loginUser = ({
  lastName = '',
  reference = '',
  dateOfBooking = '',
}) => {
  const params = new URLSearchParams();
  params.append('surname', trimString(lastName));
  params.append('reference', trimString(reference));
  const newDate = new Date(trimString(dateOfBooking));
  params.append('departureDate', newDate.getTime());

  return selfServiceApiClient.post('/api/self-service/login', params, {
    headers: unAuthHeader(),
    withCredentials: true,
  });
};

/**
 * Fetches current logged in user(visitor) data
 *
 * @returns {Promise<import('axios').AxiosResponse<any, any>>}
 */
export const getMe = () => {
  return selfServiceApiClient.get('/api/self-service/whoami', {
    withCredentials: true,
  });
};

function getCookieValue(name) {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? decodeURIComponent(match[2]) : null;
}

export const logout = (idpsecurityFlag) => {
  const options = {
    withCredentials: true,
  };

  if (idpsecurityFlag) {
    const csrfToken = getCookieValue('XSRF-TOKEN');
    const formData = new URLSearchParams();
    formData.append('_csrf', csrfToken);

    return selfServiceApiClient.post(
      '/api/self-service/logout',
      formData,
      { ...options, headers: { 'Content-Type': urlEncoded } }
    );
  }

  return selfServiceApiClient.get('/api/self-service/logout', options);
};

/**
 *
 * @param {object} visitor
 * @returns {Promise<import('axios').AxiosResponse<any, any>>}
 */
export const updateVisitor = (visitor) => {
  return selfServiceApiClient.put(
    `/api/self-service/visitor/${visitor._id}`, // eslint-disable-line no-underscore-dangle
    visitor,
    {
      withCredentials: true,
    },
  );
};

/**
 * Fetches payment status for a transaction GUID
 */
export const getPaymentStatus = (transactionGuid) => {
  return selfServiceApiClient.get(
    `/api/self-service/paymentstatus?transactionGuid=${transactionGuid}`,
    {},
  );
};

/**
 * Fetches payment receipt for a transaction GUID
 */
export const getPaymentReceipt = (transactionGuid, bookingRef) => {
  const bookingRefParam = bookingRef ? `&reference=${bookingRef}` : '';
  return selfServiceApiClient.get(
    `/api/self-service/document/receipt?transactionGuid=${transactionGuid}${bookingRefParam}`,
    {},
  );
};

/**
 * Fetches UI messages to be displayed for a key
 */
export const getUIMessage = (key) => {
  return selfServiceApiClient.get(
    `/api/self-service/ui-message/${key}`,
    {},
  );
};
